import * as actionTypes from "../ActionTypes";

const initialState = {
  loading: false,
  giveSettings: [],
  error: null,
  success: false,
};

const giveSettingReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_GIVESETTING_REQUEST:
    case actionTypes.UPDATE_GIVESETTING_REQUEST:
    case actionTypes.DELETE_GIVESETTING_REQUEST:
      return { ...state, loading: true, success: false, error: null };

    case actionTypes.SAVE_GIVESETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        giveSettings: [...state.giveSettings, action.payload],
      };

    case actionTypes.UPDATE_GIVESETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        giveSettings: state.giveSettings.map((item) =>
          item.giveObjId === action.payload.giveObjId ? action.payload : item
        ),
      };

    case actionTypes.DELETE_GIVESETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        giveSettings: state.giveSettings.filter(
          (item) => item.giveObjId !== action.payload.giveObjId
        ),
      };

    case actionTypes.SAVE_GIVESETTING_FAILURE:
    case actionTypes.UPDATE_GIVESETTING_FAILURE:
    case actionTypes.DELETE_GIVESETTING_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload };

    default:
      return state;
  }
};

export default giveSettingReducer;
